
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Subscription, timer } from 'rxjs';

@Component({
  selector: 'app-approveorder',
  templateUrl: './approveorder.component.html',
  styleUrls: ['./approveorder.component.css']
})
export class ApproveorderComponent implements OnInit, OnDestroy {
  loading = true;
  isSuccess = false;
  isError = false;
  message = '';
  countdown = 5;

  private timerSub?: Subscription;
  private routeSub?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.routeSub = this.route.paramMap.subscribe(params => {
      const idParam = params.get('id');

      if (!idParam || isNaN(Number(idParam))) {
        this.loading = false;
        this.isError = true;
        this.message = 'Invalid order id.';
        return;
      }

      const orderId = Number(idParam);
      this.approveOrder(orderId);
    });
  }

  approveOrder(orderId: number): void {
    this.loading = true;
    this.isSuccess = false;
    this.isError = false;
    this.message = '';
    this.http.get<any>(`Order/ApproveOrder/${orderId}`).subscribe({
      next: (res) => {
        this.loading = false;

        if (res && res.success) {
          this.isSuccess = true;
          this.message = res.message || 'Order approved successfully.';
          this.startRedirectCountdown();
        } else {
          this.isError = true;
          this.message = res?.message || 'Approval failed.';
        }
      },
      error: (err) => {
        this.loading = false;
        this.isError = true;

        if (err?.error?.message) {
          this.message = err.error.message;
        } else if (err?.message) {
          this.message = err.message;
        } else {
          this.message = 'An unexpected error occurred.';
        }
      }
    });
  }

  startRedirectCountdown(): void {
    this.countdown = 5;

    this.timerSub = timer(0, 1000).subscribe((value) => {
      this.countdown = 5 - value;

      if (this.countdown <= 0) {
        this.timerSub?.unsubscribe();
        this.router.navigate(['/']);
      }
    });
  }

  goHome(): void {
    this.router.navigate(['/']);
  }

  ngOnDestroy(): void {
    this.timerSub?.unsubscribe();
    this.routeSub?.unsubscribe();
  }
}
